import * as React from 'react'

const SvgCodeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.375 10L15 14.375l-.881-.881L17.606 10 14.12 6.506 15 5.625 19.375 10zM.625 10L5 5.625l.881.881L2.394 10l3.487 3.494-.881.881L.625 10zm7.138 5.928L11.024 3.75l1.207.323L8.97 16.25l-1.208-.322z"
      fill="#163250"
    />
  </svg>
)

export default SvgCodeIcon
